import config from "../config/environment";

const GO_BACKEND_URL = config.GO_BACKEND_URL;

export const inverterService = {
  async getInverterData() {
    const response = await fetch(`${GO_BACKEND_URL}/inverter`);
    if (!response.ok) {
      throw new Error(`Unable to load inverter data (${response.status})`);
    }
    return response.json();
  },
};

export default inverterService;
